module.exports = __webpack_public_path__ + "img/carousel.520a5be5.svg";